import { makeApiCall } from "@swiggy-private/js-utils";
import { IButtonVariant } from "@swiggy-private/dls-web-core/dist/components/Button/types";
import { ITableConfig, PinGenerationStatus, RestaurantFlow } from "@swiggy-private/portal-dineout-context";
import { customApiCall, IOptions } from "utils";
import type { IPartnerOrderToast } from "utils/types";
import { API_ENDPOINTS, DINEOUT_CART_API_HOST } from "../constants";

export interface IGeneratePinErrorInfo {
    imageId?: string;
    title?: string;
    description?: string;
    cta?: {
        text?: string;
        link?: string;
        type?: string;
        dlsType?: IButtonVariant;
    };
}

export interface IGeneratePinResponse {
    status: PinGenerationStatus;
    pin: string;
    tableNo: string;
    restaurantFlow: RestaurantFlow;
    hostName: string;
    message: string;
    parentOrderId?: string;
    partnerOrderToast?: IPartnerOrderToast;
    showMenuNudge?: boolean;
    errorInfo?: IGeneratePinErrorInfo;
}

interface IVerifyPinResponse {
    status: "SUCCESS" | "FAILURE";
    partnerOrderToast?: IPartnerOrderToast;
    parentOrderId?: string;
    showMenuNudge?: boolean;
}

export const generatePin = async (bodyParams: ITableConfig, _makeApiCall: typeof makeApiCall) => {
    const options: IOptions = {
        bodyParams: { ...bodyParams },
        method: "POST",
    };
    const response = await customApiCall<IGeneratePinResponse>({
        _makeApiCall,
        apiHost: DINEOUT_CART_API_HOST,
        apiEndpoint: API_ENDPOINTS.GENERATE_PIN,
        opts: options,
    });
    return response;
};

export const verifyPinApi = async (bodyParams: ITableConfig & { pin: string }, _makeApiCall: typeof makeApiCall) => {
    const options: IOptions = {
        bodyParams: { ...bodyParams },
        method: "POST",
    };
    const response = await customApiCall<IVerifyPinResponse>({
        _makeApiCall,
        apiHost: DINEOUT_CART_API_HOST,
        apiEndpoint: API_ENDPOINTS.VERIFY_PIN,
        opts: options,
    });
    return response;
};
